export const ADMIN = "ADMIN"
export const ADMIN_PU = "ADMIN_PU"
export const USER = "USER"

const menu = {
    isValid(user) {
        return (
            user.role === ADMIN ||
            user.role === ADMIN_PU
        )

    }
}
export default {
    data() {
        return {
            roles: [
                ADMIN,
                ADMIN_PU,
                USER,
            ],
            ruleSet: {
                menu,
            }
        }
    },
    methods: {
        getRoles() {
            return this.roles
        },
        getUserRole() {
            return this.$t(`role.${this.$auth.user().role}`)
        },
        userHasRole(role) {
            return this.$auth.user()?.role === role
        },
        visibleRoles() {
            let roles = [ADMIN, USER]
            if (this.$auth.user().role === ADMIN_PU)
                roles.push(ADMIN_PU)
            return roles.sort()
        },
        canShow(strategy) {
            return strategy.isValid(this.$auth.user())
        },
        isAdminPu() {
            return this.userHasRole(ADMIN_PU)
        }
    }
}
